import { render, staticRenderFns } from "./ViewOrtho.vue?vue&type=template&id=4d34ce5a&"
import script from "./ViewOrtho.vue?vue&type=script&lang=ts&"
export * from "./ViewOrtho.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d34ce5a')) {
      api.createRecord('4d34ce5a', component.options)
    } else {
      api.reload('4d34ce5a', component.options)
    }
    module.hot.accept("./ViewOrtho.vue?vue&type=template&id=4d34ce5a&", function () {
      api.rerender('4d34ce5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboards/ViewOrtho.vue"
export default component.exports